var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 36,
    viewBox: "0 0 190 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1160_4136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7979 12.8074L21.7666 12.8741L21.7925 12.8074H21.7979Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4302 13.9305C36.0975 20.1254 31.1337 25.1583 24.866 25.4046C18.2252 25.6653 12.63 20.4556 12.3555 13.7618L36.4302 13.9305Z",
    fill: "#5E514D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5148 13.9305C28.3286 13.9305 31.4203 10.8121 31.4203 6.96527C31.4203 3.11846 28.3286 0 24.5148 0C20.7011 0 17.6094 3.11846 17.6094 6.96527C17.6094 10.8121 20.7011 13.9305 24.5148 13.9305Z",
    fill: "#5E514D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 35.991L6.35273 25.0825L43.0336 25.3703L49 36L0 35.991Z",
    fill: "#5E514D"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65 25.2837V10.7163H67.2519L73.6928 21.3503H72.5132L78.8491 10.7163H81.101L81.1421 25.2837H78.5114V14.7331H79.0385L73.6928 23.6395H72.4516L66.9781 14.7331H67.6101V25.2837H65Z",
    fill: "#5E514D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9875 25.2837V19.519L94.6195 21.1631L88.1992 10.7163H91.1036L96.2828 19.1446H94.6401L99.7987 10.7163H102.493L96.0934 21.1631L96.7049 19.519V25.2837H93.9898H93.9875Z",
    fill: "#5E514D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112.322 25.2837V13.0055H107.438V10.7163H119.943V13.0055H115.058V25.2837H112.322Z",
    fill: "#5E514D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M127.269 25.2837V10.7163H130.004V25.2837H127.269Z",
    fill: "#5E514D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M139.247 25.2837V10.7163H145.309C146.614 10.7163 147.732 10.9215 148.668 11.3298C149.601 11.7402 150.319 12.3311 150.826 13.1092C151.33 13.8873 151.583 14.8166 151.583 15.8969C151.583 16.9772 151.33 17.8838 150.826 18.6552C150.322 19.4243 149.601 20.0219 148.668 20.4459C147.734 20.8699 146.614 21.0797 145.309 21.0797H140.783L141.983 19.8325V25.2837H139.247ZM141.983 20.1212L140.783 18.7905H145.181C146.388 18.7905 147.296 18.5379 147.908 18.0304C148.517 17.523 148.823 16.8125 148.823 15.8969C148.823 14.9812 148.517 14.2708 147.908 13.7633C147.296 13.2558 146.388 13.0032 145.181 13.0032H140.783L141.983 11.6726V20.1212Z",
    fill: "#5E514D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M162.318 22.9945H170.632V25.2837H159.58V10.7163H170.338V13.0055H162.318V22.9945ZM162.108 16.7719H169.434V18.998H162.108V16.7719Z",
    fill: "#5E514D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M181.684 22.9945H189.998V25.2837H178.946V10.7163H189.704V13.0055H181.684V22.9945ZM181.474 16.7719H188.8V18.998H181.474V16.7719Z",
    fill: "#5E514D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1160_4136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fe9261c01a542b8596279c81601d4d43.svg";
export { ForwardRef as ReactComponent };